import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { TempiConservazioneVO } from "../vo/tempi-conservazioneVO";
import { TempiConservazioneDTO } from "../dto/tempi-conservazioneDTO";
import { MapperCampoSpecificoConservazione } from "./mapper-campo-specifico-conservazione";

@Injectable({
  providedIn: "root",
})
export class MapperTempiConservazione
  implements MapperInterface<TempiConservazioneDTO, TempiConservazioneVO> {
  constructor(
    private mapperCampoSpecificiConservazione: MapperCampoSpecificoConservazione
  ) {}
  convertVoToDto(vo: TempiConservazioneVO): TempiConservazioneDTO {
    if (vo != null) {
      const dto = new TempiConservazioneDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.campoSpecificoConservazione = this.mapperCampoSpecificiConservazione.convertVoToDto(
        vo.campoSpecificoConservazione
      );
      dto.motivazione = vo.motivazione;
      // dto.numeroAnniDaApertura = vo.numeroAnniDaApertura;
      dto.ereditaDaFascicolo = vo.ereditaDaFascicolo;
      dto.numeroAnniDaChiusura = vo.numeroAnniDaChiusura;
      dto.perSempre = vo.perSempre;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: TempiConservazioneDTO): TempiConservazioneVO {
    // console.log("MapperTempiConservazione convertDtoToVo begin", dto);
    if (dto != null) {
      const vo = new TempiConservazioneVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.campoSpecificoConservazione = this.mapperCampoSpecificiConservazione.convertDtoToVo(
        dto.campoSpecificoConservazione
      );
      vo.motivazione = dto.motivazione;
      //vo.numeroAnniDaApertura = dto.numeroAnniDaApertura;
      vo.ereditaDaFascicolo = dto.ereditaDaFascicolo;
      vo.numeroAnniDaChiusura = dto.numeroAnniDaChiusura;
      vo.perSempre = dto.perSempre;
      //  console.log("MapperTempiConservazione convertDtoToVo end", vo);
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: TempiConservazioneVO[]): TempiConservazioneDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: TempiConservazioneDTO[]): TempiConservazioneVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
